import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const fieldName = `rules.${RuleType.FileType}`;

export interface IFileTypeRuleComponentProps {}

export function FileTypeRuleComponent(props: IFileTypeRuleComponentProps) {
  return (
    <FormItem name={`${fieldName}.value`} label="Formati file ammessi">
      <$SpaceCompact block size="large">
        <SelectInput
          name={`${fieldName}.value`}
          mode="tags"
          style={{ width: '100%' }}
          placeholder="Scrivi e premi invio per aggiungere..."
        />
        <CustomValidationRuleMessage name={`${fieldName}.customMessage`} />
      </$SpaceCompact>
    </FormItem>
  );
}
